module.exports = __webpack_public_path__ + "img/14.29d61f9b.jpg";